module.exports = __webpack_public_path__ + "static/img/footer2.571fd2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/works/footer2.png
// module id = Fkwl
// module chunks = 1